import { useCallback, useEffect, useRef } from 'react';

/**
 * lose context on unmount, so hopefully we can free up the number of webGl contexts for other maps
 */
export const useWebGlContextCleanup = () => {
  const webGlRef = useRef<WebGLRenderingContext>();

  // cleanup webgl context on unmount
  useEffect(() => {
    return () => {
      const extension = webGlRef.current?.getExtension('WEBGL_lose_context');
      extension?.loseContext();
    };
  }, []);

  const setWebGlRef = useCallback((gl: WebGLRenderingContext) => {
    webGlRef.current = gl;
  }, []);

  return { setWebGlRef };
};
